import { Controller } from "stimulus"

const AUTO_DISMISS_MS = 6000

export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.dismiss(), AUTO_DISMISS_MS)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss(event) {
    if (event) event.preventDefault()
    this.element.style.transition = "opacity 0.3s ease"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.remove(), 300)
  }
}
